module.exports = __webpack_public_path__ + "img/about-bg1.3ce4e7f5.png";